import { render, staticRenderFns } from "./RecebimentoDetalhe.vue?vue&type=template&id=4800ca6b&scoped=true"
import script from "./RecebimentoDetalhe.vue?vue&type=script&lang=ts"
export * from "./RecebimentoDetalhe.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoDetalhe.vue?vue&type=style&index=0&id=4800ca6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800ca6b",
  null
  
)

export default component.exports